import {
	ApolloLink,
	ApolloClient,
	HttpLink,
	InMemoryCache
} from '@apollo/client';
// import { createUploadLink } from 'apollo-upload-client';
import { onError } from '@apollo/client/link/error';

console.log(process.env, process.env?.REACT_APP_API_ENDPOINT)
const API_ENDPOINT = process.env?.REACT_APP_API_ENDPOINT;

const createApolloClient = () => {
	// const authToken = "";
	const authToken = `Bearer ${window.localStorage.getItem('token')}`;
	const ERROR_LINK = onError(({ networkError }: any) => {
		if (networkError && (networkError?.response?.status == 401 || networkError?.response?.status == 403)) {
			window.localStorage.removeItem("token");
			// window.localStorage.removeItem(JWT_TOKEN_COGNITO);
			// window.localStorage.clear()
			location.reload();
			console.error("Network error")
		}
	});

	const HTTP_LINK = new HttpLink({
		uri: `${API_ENDPOINT}/graphql`,
		headers: {
			authorization: authToken,
			api: authToken
		}
	});

	// const UPLOAD_LINK = createUploadLink({
	// 	uri: `${REACT_APP_API_URL}/graphql`,
	// 	headers: {
	// 		authorization: `Bearer ${window.localStorage.getItem(
	// 			''
	// 		)}`,
	// 		api: `Bearer ${window.localStorage.getItem('')}`
	// 	}
	// });

	return new ApolloClient({
		link: ApolloLink.from([ERROR_LINK, HTTP_LINK]),
		cache: new InMemoryCache()
	});
};

export default createApolloClient;
